import { useInjection } from 'inversify-react';

import { Button } from '@desygner/ui-common-components';

import { VideoManager } from '../../../../../core/viewer/video-manager';
import { TYPES } from '../../../../../inversify.types';
import { useViewerStore } from '../../../../../store';

export const PauseButton = () => {
  const videoManager = useInjection<VideoManager>(TYPES.Viewer.VideoManager);
  const currentMediaMetadata = useViewerStore((state) => state.currentPlayingMedia);

  function handlePauseVideo() {
    if (!currentMediaMetadata) return;

    videoManager.pauseCurrentActiveVideo();
  }

  if (!currentMediaMetadata) return null;

  return (
    <Button
      icon={{
        name: !currentMediaMetadata ? 'video-play' : 'video-pause',
      }}
      size="Small"
      variant="ghost"
      onClick={handlePauseVideo}
      action="navigation-page"
      dataset={{
        direction: 'previous',
      }}
    />
  );
};
